<ion-header>
  <ion-toolbar mode="md" color="dark">
    <ion-title>{{ 'payment.chargeToDepartment' | transloco }}</ion-title>
    <ion-buttons slot="end">
      <ion-button
        mode="md"
        debounce-click
        [debounceTime]="0"
        (debounceClick)="onCloseModal()"
        >{{ 'common.close' | transloco }}</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen>
  <div class="department-charge-account-payment-modal">
    <div class="ion-padding">
      <p>{{ 'payment.businessLine' | transloco }}</p>
      <ion-select
        translocoSelect
        [placeholder]="'payment.selectBusinessLine' | transloco"
        [ngModel]="''"
        (ionChange)="onSelectBusinessLine($event)">
        <ion-select-option [value]="''"
          >{{ 'common.all' | transloco }}</ion-select-option
        >

        <ion-select-option *ngFor="let item of businessLines" [value]="item"
          >{{item.name}}</ion-select-option
        >
      </ion-select>
    </div>
    <div class="ion-padding">
      <p>{{ 'payment.department' | transloco }}</p>
      <ng-select
        [minTermLength]="minLengthTerm"
        [notFoundText]="'posManager.noItemsFound' | transloco"
        [loading]="departmentLoading"
        [typeToSearchText]="'dining.minimumCharactersRequired' | transloco: { count: minLengthTerm }"
        [typeahead]="searchKey$"
        [(ngModel)]="selectedDepartment">
        <ng-option *ngFor="let item of departments$ | async" [value]="item"
          >{{item.name}} ({{item.code}})</ng-option
        >
      </ng-select>
    </div>
    <div *ngIf="selectedDepartment">
      <p class="ion-padding-horizontal">
        {{ 'payment.chargeAccount' | transloco }}
      </p>
      <ion-list class="ion-no-padding">
        <ion-item *ngFor="let item of selectedDepartment.charge_accounts">
          <ion-label>{{item.name}}</ion-label>
          <ion-button
            mode="md"
            color="dark"
            (click)="onSelectChargeAccount(item)">
            {{ 'common.select' | transloco | uppercase }}
          </ion-button>
        </ion-item>
      </ion-list>
    </div>
  </div>
</ion-content>
